/* eslint-disable react/no-children-prop */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { AppSelectors } from 'store/appModule/selectors';
import { AppActions } from 'store/appModule/actions';

import Router from '../routes';
import './AppContainer.less';

/**
 * @augments {Component<{    onLoad:Function, appLoaded: Boolean  >}
 */
class AppContainer extends Component {
  static propTypes = {
    appLoaded: PropTypes.bool,
    onLoad: PropTypes.func,
  };

  componentDidMount() {
    this.props.onLoad();
  }

  render() {
    return (
      <div>
        <Router />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  appLoaded: AppSelectors.appLoadedSelector(state),
});

const mapActionCreators = {
  onLoad: AppActions.startUp,
};

const withConnect = connect(mapStateToProps, mapActionCreators);

export default withConnect(AppContainer);
